import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
import { getLocalPosition } from "./LocalPosition";
import { createMapMarker } from "./Markers";

export function enableCurrentLocationControl(params) {
    let controlDiv = document.createElement("div");
    controlDiv.style.cursor = "pointer";

    let buttonChild = document.createElement("button");
    buttonChild.style.backgroundColor = "#fff";
    buttonChild.style.border = "none";
    buttonChild.style.outline = "none";
    buttonChild.style.width = "28px";
    buttonChild.style.height = "28px";
    buttonChild.style.borderRadius = "2px";
    buttonChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
    buttonChild.style.marginRight = "10px";
    buttonChild.style.padding = "0";
    buttonChild.title = params.currentLocationLabel;
    controlDiv.appendChild(buttonChild);

    let iconChild = document.createElement("div");
    iconChild.style.margin = "5px";
    iconChild.style.width = "18px";
    iconChild.style.height = "18px";
    iconChild.style.backgroundImage =
        "url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)";
    iconChild.style.backgroundSize = "180px 18px";
    iconChild.style.backgroundPosition = "0 0";
    iconChild.style.backgroundRepeat = "no-repeat";
    buttonChild.appendChild(iconChild);

    buttonChild.addEventListener("click", function() {
        getLocalPosition(params.errorMessages, params.apiKey).then(
            response => {
                let currentLocationMarker = createMapMarker(response, {
                    location: { icon: "http://maps.google.com/mapfiles/ms/icons/green-dot.png" }
                });
                currentLocationMarker.setMap(params.map);
                params.map.setCenter(response);
                params.map.setZoom(params.zoom);
                iconChild.style["background-position"] = "-144px 0";
            },
            error => {
                iconChild.style["background-position"] = "0 0";
                WEBUILogs.error(error);
            }
        );
    });

    controlDiv.index = 1;
    params.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
}

// Create the search box and link it to the UI element.
export function createSearchField(map) {
    let input = document.createElement("input");
    input.type = "text";
    input.placeholder = "Search places...";
    let searchBox = new window.google.maps.places.SearchBox(input);
    map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(input);
    // when we change the searched location we want the map to fit / zoom ne new location if found
    searchBox.addListener("places_changed", function() {
        let places = searchBox.getPlaces();

        if (places.length === 0) {
            return;
        }

        let searchBounds = new window.google.maps.LatLngBounds();
        places.forEach(function(place) {
            searchBounds.union(place.geometry.viewport);
        });
        map.fitBounds(searchBounds);
    });
}
